import {
  type LearningModule,
  LearningModuleInput
} from '@/core/domain/learning/module/LearningModule.ts'
import type { ILearningModuleRepository } from '@/core/domain/learning/module/ILearningModuleRepository.ts'

export class UpdateLearningModuleUseCase {
  private readonly learningModuleRepository: ILearningModuleRepository

  constructor(learningModuleRepository: ILearningModuleRepository) {
    this.learningModuleRepository = learningModuleRepository
  }

  async execute(
    courseId: number,
    moduleId: number,
    module: LearningModuleInput
  ): Promise<LearningModule> {
    return await this.learningModuleRepository.updateLearningModule(courseId, moduleId, module)
  }
}
